var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8571 10.9008V7.22698H12V11.9995H7.275V10.9008H10.8571ZM12 -0.000488281V4.77204H10.8571V1.09822H7.275V-0.000488281H12ZM1.14286 10.9008H4.72143V11.9995H-9.53674e-07V7.22698H1.14286V10.9008ZM4.72143 -0.000488281V1.09822H1.14286V4.77204H-9.53674e-07V-0.000488281H4.72143Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpand);
export default __webpack_public_path__ + "static/media/expand.e9f32103f39f3f96be38976e83f513aa.svg";
export { ForwardRef as ReactComponent };